import { useContext } from 'react';

import { AdminExamCenterProctorRequestDetailsContext } from './admin-exam-center-proctor-request-details-provider';

function useAdminExamCenterProctorRequestDetails() {
  const context = useContext(AdminExamCenterProctorRequestDetailsContext);

  if (!context) {
    throw new Error(
      'useAdminExamCenterProctorRequestDetails must be used within a AdminExamCenterProctorRequestDetailsProvider',
    );
  }

  return context;
}

export { useAdminExamCenterProctorRequestDetails };
